import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { formatDinero } from '../../../utils/formatDinero';
import { catTipoCambio } from '../../../constant/catTipoCambios';
const useStyles = makeStyles({
  root: {
    minWidth: 275,
    margin: "15px 15px"
  },
  pos: {
    marginBottom: 5,
  },
});

export default function SimpleCard(props) {
  const { Nombre = '', Referencia = '', tipoCambio = 0, moneda = {}, montoMensual = {} } = props;
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography className={classes.pos} variant="h5" component="h2">
          {`${Nombre}`}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {`No. referencia: ${Referencia}`}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {`Pago mensual sugerido: ${formatDinero((moneda.id_moneda === catTipoCambio.DOLARES) ? montoMensual * tipoCambio : montoMensual)} Pesos`}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {`Tipo cambio hoy: ${formatDinero(tipoCambio)}`}
        </Typography>
      </CardContent>
    </Card>
  );
}